var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M16 6a1 1 0 1 0 0 2h3.586L13 14.586l-4.293-4.293a1 1 0 0 0-1.414 0l-6 6a1 1 0 1 0 1.414 1.414L8 12.414l4.293 4.293a1 1 0 0 0 1.414 0L21 9.414V13a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }